import BaseModel from "~/models/BaseModel";

class MediumFollowModel extends BaseModel {}
export default MediumFollowModel;
